import { render, staticRenderFns } from "./subHeader.vue?vue&type=template&id=b3f1a848&scoped=true&"
import script from "./subHeader.vue?vue&type=script&lang=js&"
export * from "./subHeader.vue?vue&type=script&lang=js&"
import style0 from "./subHeader.vue?vue&type=style&index=0&id=b3f1a848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1a848",
  null
  
)

export default component.exports